import CryptoJS from "crypto-js";

const createRequestData = (body) => {
  const timestamp = Date.now();
  const nonce = Math.floor(Math.random() * 10000).toString();
  const content = JSON.stringify({ ...body });

  // Parametreleri encode et
  const encodedContent = encodeURIComponent(content);

  // Parametreleri birleştir
  const params = {
    content: encodedContent,
    appKey: process.env.REACT_APP_API_KEY,
    timestamp: timestamp,
    nonce: nonce,
  };

  // Parametreleri ASCII sırasına göre dizip birleştir
  const sortedParams = Object.keys(params)
    .sort()
    .map((key) => `${key}=${params[key]}`)
    .join("&");
  const stringToSign = `${sortedParams}&appSecret=${process.env.REACT_APP_API_SECRET}`;

  // MD5 ile hash al ve küçük harfe çevir
  const sign = CryptoJS.MD5(stringToSign).toString();

  // İstek verisi oluştur
  return {
    content: encodedContent,
    appKey: process.env.REACT_APP_API_KEY,
    timestamp: timestamp,
    nonce: nonce,
    sign: sign,
  };
};

const apiFunction = (input, url, method) => {
  const { token, ...filteredData } = input;
  const requestData = createRequestData({
    ...filteredData,
  });

  return {
    url: url,
    method: method,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: {
      ...requestData,
    },
  };
};

const URL = {
  url: "",
  url1: "",
};

export { createRequestData, apiFunction, URL };
